import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PaymentService } from '../payment.service';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../../views/auth/auth.service';

@Component({
  selector: 'app-subscription-plans',
  templateUrl: './subscription-plans.component.html',
  styleUrls: ['./subscription-plans.component.scss']
})
export class SubscriptionPlansComponent implements OnInit {
  name: string;
  showPopup = false;
  check: any;
  closeResult: string;
  
  public sidebarMinimized = false;
  email$: string;
  constructor(private router: Router, private payService:PaymentService,private modalService: NgbModal,private authService :AuthService) { }

  ngOnInit(): void {
this.email$=localStorage.getItem('email')
    this.payService.checkActiveSub(localStorage.getItem("email")).subscribe(
      data =>{
this.check=data;

      },
      error => {
console.log(error,"error");

       }
    );
  }

   
  logout(content):void {
    //27/12/2022
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }


  signout():void{
    this.authService.logout(this.email$).subscribe(
      data => {

      localStorage.setItem('token', '')
      localStorage.setItem('email','')
      this.router.navigate(['/']);

     


      },
      error => {
        console.log(error, 'error')
        if (error.status == 404) {
         
        }
        else if (error.status == 401) {
          
        }

      }
    );
    
}
toggleMinimize(e) {
    this.sidebarMinimized = e;
  }



Gotoprofile(){

  this.router.navigate(['/Profile/profile']);

}

GotoprofileSecurity(){

  this.router.navigate(['profilesecurity/profilesecurity']);

}


GotoSupport(){

  this.router.navigate(['support/support']);

}


GotoAbonnement(){

  this.router.navigate(['accountbilling/accountbilling']);

}



  basicplan(){


    localStorage.setItem('Plan','basic');
    this.router.navigate(['/payment']);


  }
  intermediateplan(){
    localStorage.setItem('Plan','intermediate');
    this.router.navigate(['/payment']); 
  }

  advancedplan(){

    localStorage.setItem('Plan','advanced');
    this.router.navigate(['/payment']);
  
  }

  
      
  onSubmit() {
    if (!this.name) {
      this.showPopup = true;
    } else {
      // Submit form
    }
  }

  closePopup() {
    this.showPopup = false;
  }


}
